import {
    StyledFooterWrapper,
    StyledFooterImg,
    StyledFooterSectionText,
    StyledFooterSectionTitle,
    StyledFooterContnetWrapper,
    StyledFooterGridItem,
    StyledFooterGridContainer,
} from "./Footer.styled";
import Box from "@mui/material/Box";
import Neo_CRF_logo from "commons/assets/neo-crf.png";
import {
    PROJECT_PRIMARY_EMAIL,
    PROJECT_PRIMARY_PHONE,
    PROJECT_TECHNICAL_EMAIL,
    PROJECT_TECHNICAL_PHONE
} from "../../../commons/constants/env";
import { useTranslation } from "react-i18next";

const Footer = () => {
    const { t } = useTranslation();

    return (
        <StyledFooterWrapper>
            <StyledFooterContnetWrapper>
                <StyledFooterGridContainer>
                    <StyledFooterGridItem>
                        <Box flexGrow={1} display="flex" alignItems="center" pb={1}>
                            <StyledFooterImg src={Neo_CRF_logo} alt="NeoCRF" marginRight={24}/>
                            <Box display="flex" flexDirection="column">
                                <StyledFooterSectionTitle>NEO-CRF</StyledFooterSectionTitle>
                                <StyledFooterSectionText>
                                    Neo-Vinci sp. z o.o.
                                </StyledFooterSectionText>
                                <StyledFooterSectionText>
                                    ul. Puławska 14 | 02-512 Warszawa
                                </StyledFooterSectionText>
                            </Box>
                        </Box>
                    </StyledFooterGridItem>
                    <StyledFooterGridItem>
                        <Box flexGrow={1} display="flex" pb={1}>
                            <Box display="flex" flexDirection="column">
                                <StyledFooterSectionTitle>
                                    {t('contact-technical-matters')}:
                                </StyledFooterSectionTitle>
                                <StyledFooterSectionText>
                                    e-mail: {PROJECT_TECHNICAL_EMAIL}<br/>
                                    {t('phone')}: {PROJECT_TECHNICAL_PHONE}
                                </StyledFooterSectionText>
                            </Box>
                        </Box>
                    </StyledFooterGridItem>
                  {(PROJECT_PRIMARY_EMAIL || PROJECT_PRIMARY_PHONE) &&
                    <StyledFooterGridItem>
                      <Box flexGrow={1} display="flex" pb={1}>
                        <Box display="flex" flexDirection="column">
                          <StyledFooterSectionTitle>
                            {t('contact-substantive-matters')}:
                          </StyledFooterSectionTitle>
                          <StyledFooterSectionText>
                            e-mail: {PROJECT_PRIMARY_EMAIL}<br/>
                            {t('phone')}: {PROJECT_PRIMARY_PHONE}
                          </StyledFooterSectionText>
                        </Box>
                      </Box>
                    </StyledFooterGridItem>
                  }
                </StyledFooterGridContainer>
            </StyledFooterContnetWrapper>
        </StyledFooterWrapper>
    );
};

export default Footer;
